<div id="heading">
    <h1>Messages</h1>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">About Us</a></li>
            <li class="breadcrumb-item active" aria-current="page">Messages</li>
        </ol>
    </nav>
</div>

<div id="messages">
    <div class="container-fluid">
        <div class="row text-center">
            <div class="col-12">
                <h3>Visionary Management</h3>
                <hr class="pb-2 rounded">
            </div>
        </div>
        <!---<div class="row mt-5 mb-5 line" id="patron">
            <div class="col-12 col-md-12 col-lg-4 messagePatron text-center">
                <div class="image">
                    <img src="/assets/img/message/1.jpeg" alt="Patron" class="img-fluid w-100 rounded">
                    <div class="category-banner">
                        Patron
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-12 col-lg-8 detail text-justify">
                <h2>S. Bhupinder Singh Jauhar</h2>
                <p class="lead">Guru Nanak Khalsa College was founded in 1968 when the world was celebrating 500th Birth
                    Anniversary of Sri Guru Nanak Dev Ji, a great saint and philosopher from India.
                    Right from its inception the college committed itself to follow the philosophy and teachings of this
                    great Guru ji who believed in the oneness of humanity and envisioned a casteless society where every
                    body had equal opportunity to grow and succeed.
                    Today, in its Golden Jubilee year, Guru Nanak Khalsa College, Yamuna Nagar is one of the premier
                    institutions of Haryana imparting career-oriented and ethical education to one and all.
                    It has already received top most grading and honours from NAAC and Kurukshetra University on account
                    of its outstanding achievements in the fields of academics, sports, community services and extra
                    curricular activities. The management, students and staff of the college have always striven to take
                    the college on the path of excellence through their consistent and dedicated efforts.
                    I extend my best wishes to the students, teachers and the entire team of Guru Nanak Khalsa
                    Institutions for doing tremendous work to take the college to new heights and earnestly desire that
                    students of this college prove to be important assets to our society and country.</p>
            </div>
        </div>
        <hr class="divider">-->
        <div class="row mt-5 mb-5" id="president">
            <div class="col-12 col-md-12 col-lg-4 messagePresident text-center">
                <div class="image">
                    <img src="/assets/img/message/6.png" alt="President" class="img-fluid w-100 rounded">
                    <div class="category-banner">
                        President
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-12 col-lg-8 detailP text-justify">
                <h2>S. Randeep Singh Jauhar</h2>
                <p class="lead">We at Guru Nanak Khalsa College are always engaged with activities for holistic
                    development
                    of our students and help them become good citizens of our country. Guru Nanak Khalsa College
                    stands committed to ensure that every individual leads a happy and contended life while
                    discharging his/her duties towards society at large. We strongly believe in forward-thinking and
                    focussing on providing students with a high-quality education and leading skill to gainful
                    employment.
                </p>
                <p class="lead">Guru Nanak Khalsa College, Yamuna Nagar is one of the premier institutions of Haryana
                    imparting career-oriented and ethical education to one and all. It has already created a name for
                    itself on account of its outstanding achievements in the fields of academics, sports, community
                    services and extra- curricular activities. The management, students and staff of the college have
                    always striven to take the college on the path of excellence through their consistent and dedicated
                    efforts. Continuing with the tradition of achieving excellence, the college got re-accredited with
                    ‘A’ grade by NAAC for the third cycle as well.</p>

                <p class="lead">I wish all students and staff the very best in their noble endeavour and hope the
                    college will
                    progress leaps and bounds in the coming days.</p>
            </div>
        </div>
        <hr class="divider">
        <div class="row mt-5 mb-5" id="principal">
            <div class="col-12 col-md-12 col-lg-4 messagePrincipal text-center">
                <div class="image">
                    <img src="/assets/img/message/9.jpg" alt="Principal" class="img-fluid w-100 rounded"
                        style="object-fit: cover;">
                    <div class="category-banner">
                        Principal
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-12 col-lg-8 detail text-justify">
                <h2>Dr. Arvinder Singh Bhalla</h2>
                <p class="lead">I am so delighted to welcome you to Guru Nanak Khalsa College, Yamuna Nagar (Haryana), where education transcends the classroom and tradition meets change. Our goal as we proceed is to transform Guru Nanak Khalsa College into a kind of higher educational institution, which  genuinely ensures a conducive and dynamic environment where dreams come true and young brains learn to visualize, create, question, explore, and lead in addition to learning. We're trying our level best to foster a robust research culture at the institution, inspiring staff and students to engage in worthwhile projects that tackle pressing issues and advance knowledge.
                </p>
                <p class="lead">Another major goal is career guidance and placements. Whether it's a dream career, further education, or entrepreneurship, we are guiding our students toward excellent prospects by fortifying our industry ties and establishing a specialized placement cell. Sports and extracurricular activities, in our opinion, are equally as crucial to the development of self-assured and competent people as academics. We're giving every student the opportunity to shine by improving our sports facilities, promoting participation in cultural events, and fostering leadership through clubs and organizations.
                </p>
                <p class="lead">We're investing in our infrastructure to enable all of this, including smart classrooms, digital resources, a dynamic library, and improved common spaces that facilitate more comfortable, collaborative, and future-ready learning. Our vision for Guru Nanak Khalsa College is straightforward i.e. to develop a college where each student feels encouraged, uplifted, and prepared to face the world. Together, we will reach new heights on this voyage of constant growth.</p>
                <p class="lead">Wishing you all the best for a bright and successful life.</p>
            </div>
        </div>
    </div>
</div>